import { getTagList } from "actions/tag";
import { showAlert } from "components/Common/commonFunctions";
import { publisherDealData } from "components/Common/constants";
import SearchableDropdown from "components/DropDown/SearchableDropdown";
import TagContentModal from "components/Modal/TagContentModal";
import ReactBsTable from "components/Tables/ReactBsTable";
import NotificationAlert from "react-notification-alert";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  Badge,
  UncontrolledTooltip,
  Col,
  Row,
  Button,
  Card,
} from "reactstrap";
import { DATE_RANGE_OPTIONS } from "variables/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const sortFieldMap = {
  deal: "DealName",
  tagName: "TagName",
  version: "Version",
  lastUpdate: "UpdatedAt",
  createdOn: "CreatedAt",
};

const Publisher_Tags = () => {
  const [data, setData] = useState({
    data: [],
    totalRecords: 0,
  });
  const [selected, setSelected] = useState(null);
  const [showLoader, setshowLoader] = useState(false);
  const [tagContentModal, setTagContentModal] = useState(false);
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setpageSize] = useState(50);
  const notificationAlertRef = useRef(null);
  const [filters, setFilters] = useState({
    deal_search: "",
    tag_search: "",
    status: "",
    date_range: "",
    start_date: "",
    end_date: "",
    filterParams: [],
  });

  const [sortConfig, setSortConfig] = useState({
    dataField: "",
    sortField: "",
    sortOrder: "",
  });

  //==> notify function is used for show success or error notification to user.
  const notify = (type, message) => {
    notificationAlertRef.current.notificationAlert({
      place: "tr",
      message: <div>{message}</div>,
      type,
      icon: "tim-icons icon-bell-55",
      autoDismiss: 5,
    });
  };

  //==> columns is used for to show columns against that tag.
  const columns = [
    // {
    //   text: "Sr. No.",
    //   dataField: "srNo",
    //   // formatter: (_, __, i) => i + 1,
    //   formatter: (_, __, rowIndex) => (pageNum - 1) * 10 + rowIndex + 1,
    // },
    {
      dataField: "deal",
      text: "Deal",
      formatter: (cell, row) => row?.deal?.dealName || "-",
      sort: true,
      sortCaret: (order) => {
        if (!order) {
          return (
            <span className="sort-caret" style={{ marginLeft: "8px" }}>
              <i className="fa fa-sort" />
            </span>
          );
        }
        return order === "asc" ? (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-up" />
          </span>
        ) : (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-down" />
          </span>
        );
      },
    },
    {
      dataField: "tagName",
      text: "Tag Name",
      sort: true,
      sortCaret: (order) => {
        if (!order) {
          return (
            <span className="sort-caret" style={{ marginLeft: "8px" }}>
              <i className="fa fa-sort" />
            </span>
          );
        }
        return order === "asc" ? (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-up" />
          </span>
        ) : (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-down" />
          </span>
        );
      },
    },
    {
      dataField: "version",
      text: "Version",
      formatter: (cell) => cell || "-",
      sort: true,
      sortCaret: (order) => {
        if (!order) {
          return (
            <span className="sort-caret" style={{ marginLeft: "8px" }}>
              <i className="fa fa-sort" />
            </span>
          );
        }
        return order === "asc" ? (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-up" />
          </span>
        ) : (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-down" />
          </span>
        );
      },
    },
    {
      dataField: "lastUpdate",
      text: "Last Updated",
      formatter: (cell) =>
        cell != "" ? moment(cell).format("DD MMM YYYY") : "-",
      sort: true,
      sortCaret: (order) => {
        if (!order) {
          return (
            <span className="sort-caret" style={{ marginLeft: "8px" }}>
              <i className="fa fa-sort" />
            </span>
          );
        }
        return order === "asc" ? (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-up" />
          </span>
        ) : (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-down" />
          </span>
        );
      },
    },
    {
      dataField: "createdOn",
      text: "Created On",
      formatter: (cell) =>
        cell != "" ? moment(cell).format("DD MMM YYYY") : "-",
      sort: true,
      sortCaret: (order) => {
        if (!order) {
          return (
            <span className="sort-caret" style={{ marginLeft: "8px" }}>
              <i className="fa fa-sort" />
            </span>
          );
        }
        return order === "asc" ? (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-up" />
          </span>
        ) : (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-down" />
          </span>
        );
      },
    },
    // {
    //   dataField: "status",
    //   text: "Status",
    //   formatter: (cell) => (
    //     <Badge color={cell === "ACTIVE" ? "success" : "danger"}>{cell}</Badge>
    //   ),
    // },
    {
      text: "Actions",
      dataField: "actions",
      formatter: (_, row) => (
        <>
          <a
            id={`copy${row.ID}`}
            className="table-action table-action-info"
            onClick={() => {
              setSelected(row);
              setTagContentModal(true);
            }}
          >
            <i className="fas fa-tag" />
          </a>
          <UncontrolledTooltip target={`copy${row.ID}`}>
            View Tag Content
          </UncontrolledTooltip>
        </>
      ),
    },
  ];

  const handleStatusToggle = (row) => {
    const isActive = row.status === "ACTIVE";

    showAlert({
      title: `Are you sure you want to ${
        isActive ? "inactivate" : "activate"
      } this tag?`,
      message: `Tag "${row.tag_name}" will be ${
        isActive ? "inactive" : "active"
      }.`,
      type: "warning",
      confirmStyle: "secondary",
      cancelStyle: "btn btn-primary btn-gradient-primary",
      confirmText: "Yes",
      cancelText: "Cancel",
      onConfirm: () => confirmStatus(row),
      onCancel: () => {},
    });
  };

  //=== Tag List Api call
  const getTagListData = async () => {
    try {
      setshowLoader(true);
      const res = await getTagList(
        pageNum,
        filters.filterParams,
        "",
        pageSize,
        sortConfig.sortField,
        sortConfig.sortOrder,
      );
      if (res.code === 200) {
        setshowLoader(false);
        setData({
          data: res?.data?.DealTag,
          totalRecords: res?.data?.totalRecords,
        }); // Set List Data according to api response.
        // notify("success", res?.message);
      } else {
        setshowLoader(false);
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Something went wrong";
        notify("danger", message);
      }
    } catch (error) {
      setshowLoader(false);
    }
  };

  useEffect(() => {
    getTagListData();
  }, [pageNum, filters.filterParams, pageSize]);

  useEffect(() => {
    if (sortConfig.sortField || sortConfig.sortOrder) {
      getTagListData();
    }
  }, [sortConfig.sortField, sortConfig.sortOrder]);

  //=== Tag List Api call

  const confirmStatus = (row) => {
    setData((prev) =>
      prev.map((item) =>
        item.id === row.id
          ? {
              ...item,
              status: item.status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
            }
          : item,
      ),
    );
  };

  //==> formatDate function is used for format the date in readable format in filters.
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  //==> isAnyFilterApplied function is used for check any filter is applied or not to avoid API call
  const isAnyFilterApplied = (filters) => {
    return Object.entries(filters).some(([key, value]) => {
      if (key === "filterParams") {
        return Array.isArray(value) && value.length > 0;
      }
      return value !== "" && value !== null && value !== undefined;
    });
  };

  //==> handleReset function is used for reset the filters.
  const handleReset = () => {
    if (!isAnyFilterApplied(filters)) return;
    setFilters({
      deal_search: "",
      tag_search: "",
      date_range: "",
      start_date: "",
      end_date: "",
      status: "",
      filterParams: [],
    });
    // setData(initialData);
  };

  //==> filterSection is used for to show filters on table.
  const filterSection = () => {
    return (
      <>
        <Row className="align-items-center">
          <Col md={2}>
            <input
              className="form-control"
              placeholder={"Deal Name"}
              value={filters.deal_search}
              onChange={(e) => handleChange("deal_search", e.target.value)}
            />
          </Col>
          <Col md={2}>
            <input
              className="form-control"
              placeholder={"Tag Name"}
              value={filters.tag_search}
              onChange={(e) => handleChange("tag_search", e.target.value)}
            />
          </Col>
          {/* <Col md={2}>
            <SearchableDropdown
              options={[
                { label: "ACTIVE", value: "ACTIVE" },
                { label: "INACTIVE", value: "INACTIVE" },
              ]}
              placeholder="Status"
              value={filters.status}
              onChange={(e) => handleChange("status", e.target.value)}
              isSearchable={false}
            />
          </Col> */}
        </Row>

        <Row className="mt-2">
          <>
            <Col md={2}>
              <SearchableDropdown
                options={DATE_RANGE_OPTIONS}
                placeholder="Date Range"
                value={filters.date_range}
                onChange={(e) =>
                  showCustomDateInputs("date_range", e.target.value)
                }
                isSearchable={false}
              />
            </Col>
            <Col md={2}>
              <div className="datepicker-wrapper">
                <DatePicker
                  selected={
                    filters.start_date ? new Date(filters.start_date) : null
                  }
                  onChange={(date) =>
                    handleChange("start_date", date ? formatDate(date) : "")
                  }
                  dateFormat="dd MMM yyyy"
                  placeholderText="Start Date"
                  className="form-control custom-datepicker"
                  disabled={filters.date_range !== "Custom Range"}
                />
                <i className="ni ni-calendar-grid-58 text-muted calendar-icon" />
              </div>
            </Col>

            <Col md={2}>
              <div className="datepicker-wrapper">
                <DatePicker
                  selected={
                    filters.end_date ? new Date(filters.end_date) : null
                  }
                  onChange={(date) =>
                    handleChange("end_date", date ? formatDate(date) : "")
                  }
                  dateFormat="dd MMM yyyy"
                  placeholderText="End Date"
                  className="form-control custom-datepicker"
                  /* ✅ disable until start date is selected */
                  disabled={
                    filters.date_range !== "Custom Range" || !filters.start_date
                  }
                  /* ✅ minDate must be a Date object */
                  minDate={
                    filters.start_date
                      ? new Date(filters.start_date)
                      : undefined
                  }
                />
                <i className="ni ni-calendar-grid-58 text-muted calendar-icon" />
              </div>
            </Col>
          </>
          <Col md={4}>
            <Button
              disabled={!isAnyFilterApplied(filters)}
              onClick={handleSearch}
              className="filter-btn-gradient-primary btn-md responsive"
            >
              Search
            </Button>

            <Button
              // className="filter-btn-gradient-secondary btn-md responsive"
              className="secondary"
              disabled={!isAnyFilterApplied(filters)}
              onClick={handleReset}
            >
              Reset
            </Button>
          </Col>
        </Row>
      </>
    );
  };

  //==> handleChange function is used for set filters values in a state.
  const handleChange = (key, value) => {
    setFilters((prev) => {
      if (key === "start_date") {
        const startDate = value;
        const endDate = prev.end_date;

        // if end_date exists AND start_date <= end_date → keep end_date
        if (endDate && new Date(startDate) <= new Date(endDate)) {
          return {
            ...prev,
            start_date: startDate,
          };
        }

        // otherwise reset end_date
        return {
          ...prev,
          start_date: startDate,
          end_date: "",
        };
      }

      return {
        ...prev,
        [key]: value,
      };
    });
  };

  //==> buildFilterParams function is used for to create filterJSON Array.
  const buildFilterParams = () => {
    const filterParams = [];

    if (filters?.status !== "") {
      filterParams.push({
        field: "Status",
        condition: "eq",
        filterValues: [filters?.status],
      });
    }

    if (filters?.deal_search != "") {
      filterParams.push({
        field: "DealName",
        condition: "like",
        filterValues: [filters?.deal_search],
      });
    }

    if (filters?.tag_search != "") {
      filterParams.push({
        field: "Name",
        condition: "like",
        filterValues: [filters?.tag_search],
      });
    }

    if (filters?.start_date !== "" && filters?.end_date !== "") {
      filterParams.push({
        field: "CreatedAt",
        condition: "btw",
        filterValues: [filters?.start_date, filters.end_date],
      });
    }

    return filterParams.length > 0 ? JSON.stringify(filterParams) : [];
  };

  const handleSearch = () => {
    if (!isAnyFilterApplied(filters)) return;
    const newfilterParams = buildFilterParams();

    setFilters({
      ...filters,
      filterParams: newfilterParams,
    });
    if (pageNum !== 1) setPageNum(1);

    // setData(result);
  };

  //==> showCustomDateInputs function is used for adjust dates according to date range.
  const showCustomDateInputs = (name, value) => {
    // handleChange(key, value);
    const today = moment().format("YYYY-MM-DD");

    if (value === "Custom Range") {
      setFilters((prev) => ({
        ...prev,
        date_range: value,
        start_date: "",
        end_date: "",
      }));
      // setShowCustomDate(true);
      return;
    }

    let months = 0;
    if (value === "Last 1 Month") months = 1;
    if (value === "Last 3 Month") months = 3;
    if (value === "Last 6 Month") months = 6;
    if (value === "Last 12 Month") months = 12;

    const startDate = moment().subtract(months, "months").format("YYYY-MM-DD");

    setFilters((prev) => ({
      ...prev,
      date_range: value,
      start_date: startDate,
      end_date: today,
    }));
    // setShowCustomDate(true);
  };

  const handleSizePerPageChange = (e) => {
    const newSize = Number(e.target.value);
    setpageSize(newSize);
    setPageNum(1);
  };

  const handleSortChange = (dataField, sortOrder) => {
    const mappedSortField = sortFieldMap[dataField] || dataField;
    setSortConfig({ dataField, sortField: mappedSortField, sortOrder });
    setPageNum(1);
  };

  return (
    <>
      <div className="rna-container">
        <NotificationAlert ref={notificationAlertRef} />
      </div>
      <Container className="mt--6" fluid>
        <Card>
          <ReactBsTable
            title="Publisher Tags"
            description="Manage ad tags"
            handleSizePerPageChange={handleSizePerPageChange}
            data={data?.data}
            columns={columns}
            keyField="ID"
            addbtntext="Add Tag"
            showAddbtn={false}
            renderFilters={filterSection}
            page={pageNum}
            sizePerPage={pageSize}
            totalRecords={data?.totalRecords}
            defaultSortField={sortConfig.dataField}
            defaultSortOrder={sortConfig.sortOrder}
            enablePageSizeManagement={true}
            onPageChange={(p) => setPageNum(p)}
            showLoader={showLoader}
            onSortChange={handleSortChange}
          />
        </Card>
        <TagContentModal
          isTagContentModalOpen={tagContentModal}
          tagModalToggle={() => setTagContentModal(false)}
          modalHeader={"Tag Content Details"}
          label={"Tag Content"}
          textAreaValue={selected?.content}
        />
      </Container>
    </>
  );
};

export default Publisher_Tags;
